import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import messages, { RequestLineItemTypeMessages } from './messages';

export const RETURN_EXCHANGE_TYPE = 'returnExchangeTypes';

export default {
  id: RETURN_EXCHANGE_TYPE,
  type: OptionFormTypes.TYPE_CHECKLIST,
  filterValue: RETURN_EXCHANGE_TYPE,
  allowsMultipleSelection: true,
  shouldHideActionButtons: true,
  displayName: (appliedFilters) => {
    const requestLineItemTypeFilters = appliedFilters.filter((filter) => filter.filterById === RETURN_EXCHANGE_TYPE);
    if (requestLineItemTypeFilters.length === 0) {
      return <FormattedMessage {...messages.returnExchangeType} />;
    }
    if (requestLineItemTypeFilters.length === 1) {
      const requestLineItemTypeKey = requestLineItemTypeFilters[0].criterionArgumentValue;
      return <FormattedMessage {...RequestLineItemTypeMessages[requestLineItemTypeKey]} />;
    }
    return <FormattedMessage {...messages.multipleReturnExchangeTypes} />;
  },
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
};
